/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free date difference calculator. Find the exact number of days, weeks, months and weekdays between two dates, or count down to a future date.`)
};

const es_dd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de diferencia de fechas gratuita. Encuentra el número exacto de días, semanas, meses y días de semana entre dos fechas, o cuenta atrás hasta una fecha futura.`)
};

const de_dd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos Datumsdifferenzrechner. Finden Sie die genaue Anzahl der Tage, Wochen, Monate und Wochentage zwischen zwei Daten oder zählen Sie bis zu einem zukünftigen Datum.`)
};

const nl_dd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis datumverschilcalculator. Vind het exacte aantal dagen, weken, maanden en weekdagen tussen twee datums, of tel af tot een toekomstige datum.`)
};

const fr_dd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice de différence de dates gratuite. Trouvez le nombre exact de jours, semaines, mois et jours de la semaine entre deux dates, ou compte à rebours jusqu'à une date future.`)
};

const it_dd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito della differenza fra date. Trova il numero esatto di giorni, settimane, mesi e giorni feriali tra due date, o fai il conto alla rovescia fino a una data futura.`)
};

const pt_br2_dd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de diferença de datas gratuita. Encontre o número exato de dias, semanas, meses e dias úteis entre duas datas, ou faça uma contagem regressiva para uma data futura.`)
};

const pt_dd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de diferença de datas gratuita. Encontre o número exato de dias, semanas, meses e dias da semana entre duas datas, ou faça uma contagem regressiva até uma data futura.`)
};

const ja_dd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の日付差計算機。2つの日付間の正確な日数、週、月、平日を見つけるか、将来の日付までカウントダウンしてください。`)
};

const zh_dd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费日期差计算器。精确计算两个日期之间的天数、周数、月数和工作日数，或为未来的日期设置倒计时。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_meta_description", locale)
	if (locale === "en") return en_dd_meta_description(inputs)
	if (locale === "es") return es_dd_meta_description(inputs)
	if (locale === "de") return de_dd_meta_description(inputs)
	if (locale === "nl") return nl_dd_meta_description(inputs)
	if (locale === "fr") return fr_dd_meta_description(inputs)
	if (locale === "it") return it_dd_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_dd_meta_description(inputs)
	if (locale === "pt") return pt_dd_meta_description(inputs)
	if (locale === "ja") return ja_dd_meta_description(inputs)
	return zh_dd_meta_description(inputs)
};